
import { useState } from "react";
import type { CurrencyCode } from "@/utils/currency";

export type WorkArrangementType = 'Full-Time' | 'Part-Time' | 'Freelance';
export type WorkPresenceType = 'Fully On-site' | 'Remote' | 'Hybrid'; // Define the type

export interface TestDetails {
  title: string;
  description: string;
  keyResponsibilities: string;
  yearsOfExperience: string;
  location: string;
  keySkills: string[];
  timeLimit: number;
  publishToJobBoard: boolean;
  workArrangement: WorkArrangementType;
  workPresence: WorkPresenceType;
  salaryRangeMin: number | null;
  salaryRangeMax: number | null;
  salaryCurrency: CurrencyCode;
  industry?: string | null;
  seniority?: string | null;
  webcamMonitoringEnabled?: boolean;
  isActive?: boolean;
  // Scheduling fields
  isScheduled?: boolean;
  scheduledStartTime?: Date | null;
  scheduledEndTime?: Date | null;
  scheduleTimezone?: string;
  // Invitation settings
  invitationOnly?: boolean;
  // Custom messages
  welcomeMessage?: string;
  completionMessage?: string;
}

export const useTestDetails = (initialDetails?: Partial<TestDetails>) => {
  const [testDetails, setTestDetails] = useState<TestDetails>({
    title: initialDetails?.title || "",
    description: initialDetails?.description || "",
    keyResponsibilities: initialDetails?.keyResponsibilities || "",
    yearsOfExperience: initialDetails?.yearsOfExperience || "",
    location: initialDetails?.location || "",
    keySkills: initialDetails?.keySkills || [],
    timeLimit: initialDetails?.timeLimit || 60,
    publishToJobBoard: initialDetails?.publishToJobBoard || false,
    workArrangement: initialDetails?.workArrangement || 'Full-Time',
    workPresence: initialDetails?.workPresence || 'Fully On-site',
    salaryRangeMin: initialDetails?.salaryRangeMin || null,
    salaryRangeMax: initialDetails?.salaryRangeMax || null,
    salaryCurrency: initialDetails?.salaryCurrency || 'INR',
    industry: initialDetails?.industry || null,
    seniority: initialDetails?.seniority || null,
    webcamMonitoringEnabled: initialDetails?.webcamMonitoringEnabled ?? true,
    isActive: initialDetails?.isActive ?? true,
    isScheduled: initialDetails?.isScheduled ?? false,
    scheduledStartTime: initialDetails?.scheduledStartTime || null,
    scheduledEndTime: initialDetails?.scheduledEndTime || null,
    scheduleTimezone: initialDetails?.scheduleTimezone || 'UTC',
    invitationOnly: initialDetails?.invitationOnly ?? false,
    welcomeMessage: initialDetails?.welcomeMessage || "",
    completionMessage: initialDetails?.completionMessage || "",
  });

  return {
    testDetails,
    setTestDetails,
  };
};
